import { render, staticRenderFns } from "./CourseCreatePlanView.vue?vue&type=template&id=a78fd846&scoped=true&%3Akey=componentKey&"
import script from "./CourseCreatePlanView.vue?vue&type=script&lang=js&"
export * from "./CourseCreatePlanView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78fd846",
  null
  
)

export default component.exports